import React from 'react';

import { type Repub } from '@cx-modules/constants';

import Icon from '~/components/icon';
import Logo from '~/components/Logo';
import MiniMyOC from '~/components/myoddschecker/components/mini-myoc';
import { useModalContext } from '~/providers/modal-context';
import { useMyOCContext } from '~/providers/myoc-context';
import { useLoaderContext } from '~/providers/loader-context';
import TrackingActions, {
  TRACKING_ACTIONS,
  TRACKING_CATEGORIES,
  TRACKING_EVENTS,
  TRACKING_LABELS } from
'~/services/actions/tracking-actions';

import type INavigationLink from '../../../../interfaces/navigation-link';
import useStore from '../../../../store';
import OCButton from '../../../button';
import Link from '../../../link';
import Menu from '../../../menu';

import Drawer from './sub-components/drawer/drawer';
import styles from './mobile-header.module.css';

interface IProps {
  isRebrandEnabled: boolean;
  pages: INavigationLink[];
  path: string;
  repub: Repub;
  resourcesUrl: string;
  subMenu: INavigationLink[];
}

function MobileHeader({
  isRebrandEnabled,
  pages,
  path,
  resourcesUrl,
  subMenu
}: IProps): JSX.Element {
  const [{ showMyOC }] = useModalContext();
  const { myocData } = useMyOCContext();
  const loaderData = useLoaderContext();

  const [stateNavDrawerOpen, setStateNavDrawerOpen] = useStore((state) => [
  state.navDrawerOpen,
  state.setNavDrawerOpen]
  );

  const [navDrawerOpen, setNavDrawerOpen] = React.useState(stateNavDrawerOpen);

  React.useEffect(() => {
    setNavDrawerOpen(stateNavDrawerOpen);
  }, [stateNavDrawerOpen]);

  const trackingActions = React.useMemo(() => new TrackingActions(), []);

  const handleNavClick = () => {
    setStateNavDrawerOpen(!navDrawerOpen);
    setNavDrawerOpen(!navDrawerOpen);

    trackingActions.eventTracking({
      event: TRACKING_EVENTS.HAMBURGER_MENU_CLICK,
      eventCategory: TRACKING_CATEGORIES.NAVIGATION,
      eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.HAMBURGER_MENU_CLICK],
      eventLabel: TRACKING_LABELS[TRACKING_EVENTS.HAMBURGER_MENU_CLICK]
    });
  };

  return (
    <>
			<div className={styles.mobileHeader} data-testid="mobile-header">
				<div className={styles.navBar}>
					<div className={styles.burgerLogo}>
						<OCButton
              noPadding
              onClick={handleNavClick}
              testId="hamburger-menu">

							<Icon icon="HamburgerMenu" className={styles.burgerIcon} />
						</OCButton>
						<Link to="" className={styles.iconWrapper}>
							<Logo
                isRebrandEnabled={isRebrandEnabled}
                resourcesUrl={resourcesUrl} />

						</Link>
					</div>
					{showMyOC &&
          <MiniMyOC
            loaderData={loaderData}
            myocData={myocData}
            type="burgerTop" />

          }
				</div>
				<div className={styles.subMenu}>
					<Menu customId="third-lvl-nav" menu={subMenu} />
				</div>
			</div>
			<Drawer
        path={path}
        open={navDrawerOpen}
        pages={pages}
        toggleDrawer={handleNavClick} />

		</>);

}

export default MobileHeader;